import api from "../local/axios/api";
import * as apipath from "../local/config/api_paths";

// Register user
export const getZones = async (Data) => {
  try {
    const response = await api.post(apipath.GetZone, Data);
    return response?.data;
  } catch (error) {
    console.log("errorerror->>>>>>>>", error.response.data);
    return error?.response?.data;
  }
};

export const getCities = async (Data) => {
  try {
    const response = await api.post(apipath.GetCities, Data);
    return response?.data;
  } catch (error) {
    console.log("errorverror->>>>>>", error.response.data);
    return error?.response?.data;
  }
};

export const postProperty = async (Data) => {
  try {
    console.log("DataDataDataData :", Data);
    const response = await api.post(apipath.postProperty, Data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response?.data;
  } catch (error) {
    console.log("errorverror->>>>>>", error.response.data);
    return error?.response?.data;
  }
};


export const dashboardStats = async (Data) => {
  try {
    const response = await api.get(apipath.dashboardStats, {}, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response?.data;
  } catch (error) {
    console.log("errorverror->>>>>>", error.response.data);
    return error?.response?.data;
  }
};


export const dashboardChat = async (data) => {
  try {
    const response = await api.get(`${apipath.dashboardChat}?period=${data}`, {}, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response?.data;
  } catch (error) {
    console.log("errorverror->>>>>>", error.response.data);
    return error?.response?.data;
  }
};


export const dashboardChatView = async (data) => {
  try {
    const response = await api.get(`${apipath.dashboardChatView}?period=${data}`, {}, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response?.data;
  } catch (error) {
    return error?.response?.data;
  }
};


export const propertyTypes = async (data) => {
  try {
    const response = await api.get(`${apipath.propertyTypes}`, {}, {
      headers: {
      },
    });
    return response?.data;
  } catch (error) {
    console.log("errorverror->>>>>>", error.response.data);
    return error?.response?.data;
  }
};
export const propertyTypesHomeFilter = async (data) => {
  try {
    const response = await api.get(`${apipath.propertyTypesHome}`, {}, {
      headers: {
      },
    });
    return response?.data;
  } catch (error) {
    console.log("errorverror->>>>>>", error.response.data);
    return error?.response?.data;
  }
};


export const facilitiesTypes = async (data) => {
  try {
    const response = await api.get(`${apipath.facilitiesTypes}`, {}, {
      headers: {
      },
    });
    return response?.data;
  } catch (error) {
    console.log("errorverror->>>>>>", error.response.data);
    return error?.response?.data;
  }
};


export const saveReport = async (Data) => {
  try {
    const response = await api.post(apipath.report, Data);
    return response?.data;
  } catch (error) {
    return error?.response?.data;
  }
};

